module.exports = __webpack_public_path__ + "img/M-2.172478c5.png";